import React from 'react'
import menuItems from './menuItems'
import Edit from '../crud/edit'
import MenuEditor from './MenuEditor'

const fields = [{
  name: 'Public Navigation Menu',
  prop: 'value',
  type: 'component',
  component: MenuEditor,
  componentProps: {
    pageFilter: page => !page.requires_membership
  }
}]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Public Navigation Menu'
      fields={fields}
      apiPath='admin/settings/services_menu'
      successRedirectPath='/settings/services_menu'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
